import { useCallback, useEffect, useRef, useState } from 'react';

/**
 * Lightweight front-end-only toast, used for demo feedback on buttons
 * that look clickable but do not submit anywhere.
 */
export function useToast() {
  const [message, setMessage] = useState('');
  const [visible, setVisible] = useState(false);
  const timer = useRef<number | null>(null);

  const show = useCallback((text: string) => {
    setMessage(text);
    setVisible(true);
    if (timer.current) {
      window.clearTimeout(timer.current);
    }
    timer.current = window.setTimeout(() => setVisible(false), 2400);
  }, []);

  useEffect(
    () => () => {
      if (timer.current) {
        window.clearTimeout(timer.current);
      }
    },
    [],
  );

  const node = visible ? (
    <div className="fixed bottom-6 left-1/2 z-[70] -translate-x-1/2 animate-toastIn">
      <div className="flex items-center gap-2 rounded-full border border-background-200 bg-background-50 px-5 py-3 shadow-sm">
        <i className="ri-information-line w-5 h-5 flex items-center justify-center text-primary-500" />
        <span className="text-sm text-foreground-800 whitespace-nowrap">{message}</span>
      </div>
    </div>
  ) : null;

  return { show, node };
}